
import { useState, useEffect } from "react";
import axios from "axios";
import "./admin.css"; // Importe o CSS correspondente
import image1 from "../assets/image-1.png";
import image2 from "../assets/image-2.png";
import { useNavigate } from "react-router-dom";
import loading_img from "../assets/loading.gif";

const Swal = require('sweetalert2')

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const AdminPage = () => {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);


  const clickEntrar = async ()=>{

    var usuario = document.getElementById('usuario').value
    var senha = document.getElementById('senha').value
    

    if (usuario == '') {
      toast.error('Usuário inválido');
      return false;
    }

    if (senha == '') {
      toast.error('Senha inválida');
      return false;
    }

    setLoading(true)

    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/loginSeja.php',
      headers: {'Content-Type': 'application/json'},
      data: {token: '6d808a40b79c1c6dc0dd1003f58d1c75', usuario: usuario,senha:senha}
    };

    try {
      var dados = await axios(options);
      setLoading(false)


      var resposta = dados.data;
      console.log(resposta)

      if(resposta.success == false){
        toast.error(resposta.message);
        return false;
      }

      localStorage.setItem('@logado','S')
      localStorage.setItem('@nome',''+resposta.data.nome)
      localStorage.setItem('@idusuario',''+resposta.data.id)
      localStorage.setItem('@token',''+resposta.data.token)
      localStorage.setItem('@usuario',''+usuario)

      navigate("/dashboard")

    } catch (error) {
        setLoading(false)
        console.log(error)
        toast.error('Encontramos um problema certifique sua conexão e tente mais tarde!');

    }
     

  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      clickEntrar();
    }
  };

 
  return (
    <>
    <ToastContainer />
    <div className="wrapper2">
      <div className="inner">
        {/* <img src={image1} alt="" className="image-1" /> */}
        <div className="div1">
          <h3>Login</h3>
          <div className="form-holder">
            <span className="lnr lnr-user"></span>
            <input type="text" className="form-control" id="usuario" placeholder="Usuário" />
          </div>

          <div className="form-holder">
            <span className="lnr lnr-user"></span>
            <input type="password" className="form-control" id="senha" placeholder="Senha"  onKeyDown={handleKeyDown} />
          </div>
          
          {loading == false&&(<button type="submit" onClick={()=>{clickEntrar()}}>
            <span>Entrar</span>
          </button>)}

           
          {loading == true&&(<button type="submit">
            <img src={loading_img} alt="" style={{width:25,height:25}} />
          </button>)}
        </div>
        <img src={image2} alt="" className="image-2" />
      </div>
    </div>
    </>
  );
};

export default AdminPage;
